import { TextField } from "@mui/material";
import { Ref } from "react";

interface TextFieldDEProps {
	value: number | null;
	label?: string;
	disabled?: boolean;
	onChange: (value: number | null) => void;
	onBlur: () => void;
	inputRef?: Ref<any | undefined>;
	pause: () => void;
	resume: () => void;
	maxDecimals?: number;
	error?: string;
}

export const NumberTextFieldDE = ({
	value,
	label,
	onChange,
	onBlur,
	disabled = false,
	pause,
	resume,
	maxDecimals,
	error,
}: TextFieldDEProps) => {
	const onFocus = () => {
		pause();
	};

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const inputValue = e.target.value;

		if (inputValue === "") {
			onChange(null);
			return;
		}

		let regex;
		if (maxDecimals === undefined || maxDecimals === null || maxDecimals < 0) {
			regex = /^(0|[1-9]\d*)(\.\d*)?$/;
		} else if (maxDecimals === 0) {
			regex = /^(0|[1-9]\d*)$/;
		} else {
			regex = new RegExp(`^(0|[1-9]\\d*)(\\.\\d{0,${maxDecimals}})?$`);
		}

		if (regex.test(inputValue)) {
			if (
				inputValue.endsWith(".") &&
				maxDecimals !== undefined &&
				maxDecimals > 0
			) {
				onChange(Number(inputValue.slice(0, -1)));
			} else {
				onChange(Number(inputValue));
			}
		}
	};

	return (
		<TextField
			fullWidth
			disabled={disabled}
			label={label}
			variant={"outlined"}
			value={value === null ? "" : value}
			type={"number"}
			error={!!error}
			helperText={error}
			onFocus={onFocus}
			onChange={handleChange}
			onKeyDown={(e) => {
				if (e.key.toLowerCase() === "e" || e.key === "-" || e.key === "+") {
					e.preventDefault();
				}
				if (
					e.key === "." &&
					(maxDecimals === 0 || (value !== null && String(value).includes(".")))
				) {
					e.preventDefault();
				}
				if (e.key === "Enter") {
					resume();
					onBlur();
				}
			}}
			onBlur={() => {
				resume();
				onBlur();
			}}
			style={{
				minWidth: "50px",
			}}
			inputProps={{
				step:
					maxDecimals && maxDecimals > 0
						? `0.${"0".repeat(maxDecimals - 1)}1`
						: "1",
			}}
		/>
	);
};
